// extracted by mini-css-extract-plugin
export default {"container":"QQdaV","spinner":"GVktN","message":"v6B2a"};